import GroupList from 'src/features/common/GroupList';
import { leadEndpoints } from 'src/configs/endpoints';
import { List } from 'src/types/common';
import { LeadSummaryView } from 'src/features/leads/view/LeadSummaryView';
import { LeadScreenStore } from 'src/stores/LeadStore';

const ByCountryList = () => {
    const filters = LeadScreenStore.useState(s => s.filters);

    const getListFilters = (list: List) => {        
        return {
            ...filters,
            countries: [list.id]
        };
    }

    return <GroupList queryGroupsEndpoint={leadEndpoints.byCountry} queryListEndpoint={leadEndpoints.getLeads} groupFilters={filters} getListFilters={getListFilters} listName='bycountry' Component={LeadSummaryView} />
}

export { ByCountryList }

export default ByCountryList;

